import { gql } from "@grandvisionhq/graphql";
const timeSlotsById = gql`
  fragment TimeSlotsById on TimeSlot {
    from
    until
  }
`;
const GET_TIME_SLOTS_BY_ID = gql`
  query GetTimeSlotsById(
    $appointmentTypeId: ID!
    $date: String
    $globalStoreId: String
    $opticianId: ID
  ) {
    timeSlots(
      appointmentTypeId: $appointmentTypeId
      date: $date
      globalStoreId: $globalStoreId
      opticianId: $opticianId
    ) {
      ...TimeSlotsById
    }
  }
  ${timeSlotsById}
`;
export {
  GET_TIME_SLOTS_BY_ID
};
//# sourceMappingURL=get-time-slots-by-id.js.map
